import dayjs from 'dayjs';

import { APP_LOCAL_DATETIME_FORMAT, TIME_LOG_DATE_FORMAT, TIME_LOG_TIME_FORMAT } from 'app/config/constants';

export const convertDateTimeFromServer = date => (date ? dayjs(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? dayjs(date).toDate() : null);

export const displayDefaultDateTime = () => dayjs().startOf('day').format(APP_LOCAL_DATETIME_FORMAT);

export const timelogDateFormat = date => dayjs(date).format(TIME_LOG_DATE_FORMAT);

export const timelogTimeFormat = date => dayjs(date).format(TIME_LOG_TIME_FORMAT);
